// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"835":"0e70f283","872":"fdb1b0fb"}[chunkId] + ".chunk.css";
};